import React, { useEffect, useState } from 'react';
import ImageHostContext from './ImageHostContext';

interface ImageHostProviderProps {
    children: React.ReactNode;
}

const ImageHostProvider: React.FC<ImageHostProviderProps> = ({ children }) => {
    const [imageHost, setImageHost] = useState('');

    useEffect(() => {
        setImageHost(process.env.IMAGE_HOST || 'http://localhost:8080');
    }, []);

    return <ImageHostContext.Provider value={imageHost}>{children}</ImageHostContext.Provider>;
};

export default ImageHostProvider;
